import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { QuotationTaskEditForm } from '@/components/features/tasks/quotation/[quotation_task_id]/QuotationTaskEditForm';

export const ApprovalQuotationTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { quotationTask: task } = useCurrentQuotationTask();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('Approval - Edit Quotation Task'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `承認待ち一覧`, path: `/w/${_w_!.identifier}/approval` },
        {
          label: `承認待ち一覧 - 申請タスク（見積）詳細`,
          path: `/w/${_w_!.identifier}/approval/teams/${_t_!.id}/sales_orders/${_so_!.id}/quotation_tasks/${task!.id}`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <QuotationTaskEditForm />
    </WorkspaceLayout>
  );
};
